import React from 'react';

const SvgVn = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="VN_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="VN_svg__b" fill="#fff">
        <use xlinkHref="#VN_svg__a" />
      </mask>
      <use fill="#FFF" xlinkHref="#VN_svg__a" />
      <path fill="#EA403F" mask="url(#VN_svg__b)" d="M0 0h28v20H0z" />
      <path
        fill="#FFFE4E"
        mask="url(#VN_svg__b)"
        d="M14 12.34l-3.527 2.514 1.302-4.13-3.481-2.578 4.33-.04L14 4l1.375 4.107 4.331.039-3.48 2.577 1.3 4.131z"
      />
    </g>
  </svg>
);

export default SvgVn;
